import { render, staticRenderFns } from "./deductionRecord.vue?vue&type=template&id=5644c93c&scoped=true"
import script from "./deductionRecord.vue?vue&type=script&lang=js"
export * from "./deductionRecord.vue?vue&type=script&lang=js"
import style0 from "./deductionRecord.vue?vue&type=style&index=0&id=5644c93c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5644c93c",
  null
  
)

export default component.exports